<template>
  <div id="divContainer" :key="reportId">
    <div ref="dashboardContainer" id="dashboardContainer"  :style="{ height: sectionHeight }"></div>
    <div v-if="spinnerShow" class="overlay">
      <object  data="../../layout/images/spinner.svg" width="100" height="100"> </object></div>

  </div>
</template>

<script>
import {ref, onMounted, watch} from 'vue';
import { getCurrentI18nFast } from "@/locales/i18n";
import * as pbi from "powerbi-client";
import axiosClient from "@/axios";
import {useRoute} from "vue-router";

export default {
  name: 'Report',
  setup() {
    // Define reactive variables using the ref() function
    const reportId = ref(null);
    const power_bi = ref(null);
    const dashboardContainer = ref(null);
    const spinnerShow = ref(true);
    const sectionHeight = ref((window.innerHeight - 100) + 'px');
    let dashboard = null;

    // Initialize router and route objects
    // const router = useRouter();
    const route = useRoute();

    // Map locale codes to Power BI locale codes
    const locale = {
      'ru': 'ru-RU',
      'en': 'en-US',
      'kk': 'kk-KZ',
    };

    function updateSectionHeight() {
      const containerHeight = dashboardContainer.value.clientHeight;
      sectionHeight.value = `${containerHeight}px`;
    }


    // Hide the spinner overlay
    function removeOverlay() {
      spinnerShow.value = false;
    }
    async function getNewAccessToken() {
      try {
        const response = await axiosClient.get('/report/' + route.params.report_id);
        return response.data.data.accessToken;
      } catch (error) {
        console.error(error);
        throw error;
      }
    }
    async function getDataFromReport(reportId){
      const response = await axiosClient.get(`/report/${reportId}`);
      return response.data.data;
    }

    async function mountNewReport(reportId){
      try{
        console.log(3)
      // Retrieve report data from the server using axiosClient
      const report = await getDataFromReport(reportId);

      // Configure the Power BI embed config object
      const config = {
        type: 'report', // report.reportType
        tokenType: 0,
        accessToken: report.accessToken,
        embedUrl: report.embedUrl,
        id: report.id,
        permissions: pbi.models.Permissions.Read,
        eventHooks: {
          accessTokenProvider: getNewAccessToken
        },
        settings: {
          filterPaneEnabled: false,
          localeSettings: {
            language: locale[getCurrentI18nFast()],
          },
          navContentPaneEnabled: false,
        },
      };
      // Embed the report in the container element
        power_bi.value = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);
      dashboard = power_bi.value.embed(dashboardContainer.value, config);

      // Hide the iframe until it's rendered

      // iframe.style.display = 'none';

      // Show the iframe when the report is rendered
      dashboard.off('loaded');

      // Handle errors during report rendering
      dashboard.on('rendered', function () {
        const iframe = dashboardContainer.value.getElementsByTagName('iframe')[0];
        iframe.frameBorder = '0';
        removeOverlay();
        // iframe.style.display = 'inline';

      });
      dashboard.on('error', function () {
        dashboard.off('error');
      });
      } catch (error) {
        // Redirect to the not_found page if there's an error loading the report
        removeOverlay();
        // router.push({name: 'not_found', params: {...route.params, locale: route.params.locale}});
        return error;
      }
    }


    // Load the report on page load
    onMounted(() => {
      updateSectionHeight();
      reportId.value = route.params.report_id;
      mountNewReport(reportId.value);
    });

    watch(() => sectionHeight.value, (newVal) => {
      const section = dashboardContainer.value;
      if (section) {
        section.style.height = newVal;
      }
    });
    // Reload the report when the report ID changes
    watch(() => route.params.report_id, (newVal) => {
      console.log(1)
      console.log(dashboardContainer.value)
      if (!newVal) return;
      reportId.value = newVal;
      spinnerShow.value = false; // Add this line to show the spinner overlay
      // const myNode = dashboardContainer.value;
      // myNode.replaceChildren();
      mountNewReport(reportId.value);
    });

    return {
      reportId,
      spinnerShow,
      sectionHeight,
      dashboardContainer
    }
  }
}
</script>

<style scoped>
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255,255,255);
  z-index: 780;
}


iframe {
  border: none;
}

body {
  height: 100%;
  margin: 0;
}

html {
  height: 100%;
  overflow: hidden;
  margin: 0;
}

#dashboardContainer {
  height: 100%;
  overflow: hidden;
}
</style>
